<template>
  <div>
    <div>
      <el-form
        ref="form"
        label-width="160px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作名称：">
              <el-input
                v-model="data.operation"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请求ip：">
              <el-input
                v-model="data.reqIp"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="日志状态：">
              <el-input
                v-model="data.status"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务类型：">
              <el-input
                v-model="data.busiType"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label=" 访问类名：">
              <el-tooltip
                class="item"
                effect="dark"
                :content="data.clss"
                placement="top"
              >
                <el-input
                  v-model="data.clss"
                  style="width:100%"
                  disabled
                />
              </el-tooltip>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="方法名：">
              <el-tooltip
                class="item"
                effect="dark"
                :content="data.method"
                placement="top"
              >
                <el-input
                  v-model="data.method"
                  style="width:100%"
                  disabled
                />
              </el-tooltip>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label=" 异常CODE：">
              <el-input
                v-model="data.excepCode"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请求时间：">
              <el-input
                v-model="data.reqTime"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="网点号：">
              <el-input
                v-model="data.orgnCode"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="请求参数：">
              <el-input
                disabled
                type="textarea"
                :rows="6"
                readonly="readonly"
                v-model="data.params"
                class='textInput'
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="异常信息：">
              <el-input
                disabled
                type="textarea"
                :rows="6"
                readonly="readonly"
                v-model="data.excepDetail"
                class='textInput'
              >
              </el-input>
            </el-form-item>

          </el-col>
        </el-row>

      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: JSON.parse(sessionStorage.getItem('sysTransactionLogDetail')),
    };
  },
};
</script>
<style scoped lang="scss">
</style>
